import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-6 bg-gray-50" data-id="element-59">
      <div className="max-w-3xl mx-auto text-center" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-10 md:p-14 rounded-[2.5rem] shadow-xl border border-gray-100 relative" data-id="element-61">
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 bg-primary rounded-full flex items-center justify-center shadow-lg border-4 border-white" data-id="element-62">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-63" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mt-6 mb-6" data-id="element-64">
            Probala durante 7 días sin riesgo
          </h2>

          <div className="space-y-4 text-lg text-gray-600 leading-relaxed max-w-xl mx-auto" data-id="element-65">
            <p data-id="element-66">Accedé al material.</p>
            <p data-id="element-67">Revisá todas las recetas.</p>
            <p data-id="element-68">Explorá los bonus.</p>
            <p className="font-medium text-gray-900 mt-6" data-id="element-69">
              Y si sentís que no era lo que buscabas, simplemente solicitás tu
              devolución.
            </p>
            <p className="text-primary font-bold text-xl mt-4" data-id="element-70">
              Sin complicaciones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}